import { call, put } from 'redux-saga/effects';

import { creators as CompanySettingsActions } from '../../Reducers/CompanySettings';
import Api from '../../Api/DefaultApi';

export function* getAllCompanySettings() {
  try {
    const response = yield call(Api.getAllCompanySettings, null);
    if (response.status === 200) {
      yield put(
        CompanySettingsActions.companySettingsSuccess({
          company_settings: response.data,
        }),
      );
    } else {
      yield put(CompanySettingsActions.companySettingsFailure(response.message));
    }
  } catch (e) {
    yield put(CompanySettingsActions.companySettingsFailure(e));
  }
}
